<script>
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { http } from "../../../helpers/easyindustriaapi/config";
import { applyEmpresaEvolutionPolicyDefaults } from "@/helpers/evolution-policy";
import WorkingHoursForm from "./partials/WorkingHoursForm.vue";

export default {
  page: {
    title: "Alterar Empresa",
    meta: [{ name: "description", content: appConfig.description }],
  },
  props: {
    currentEmpresa: {},
    oldEmpresa: { type: Object },
    ibge: { type: Array },
    array_certificados: { type: Array },
  },
  components: {
    Multiselect,
    WorkingHoursForm,
  },
  data() {
    return {
      cepLoading: false,
      select_regime_trib: null,
      certificados:[],
      select_ambiente:null,
      select_emp_uf:null,
      abr_certificado: false,
      array_uploads: [],
      certificado: {
        razao_social: null,
      },
      certificado_bol: false,
      password: null,
      file: null,
      razao: null,
      uf: null,

      editando: false,
      titleBody: "Alterar Empresa",
      list2_cfop: ["one", "two", "tree"],
      tipos: [
        {
           id:1,
           nome:"Produção"

        },
        {
           id:2,
           nome:"homologação"
        },
      ],
      regimes: [
        {
          id: 1,
          nome: "Simples Nacional",
        },
        {
          id: 2,
          nome: "Simples Nacional - excesso de sublimite da receita bruta",
        },
        {
          id: 3,
          nome: "Regime Normal",
        },
      ],
      estados: [],
      diretorio: null,
      empresa:null,
      workingHoursLoading: false,
      workingHoursSaving: false,
      workingHours: [],
      agendaSlotDurationOptions: [
        { value: 30, text: '30 minutos' },
        { value: 40, text: '40 minutos' },
        { value: 60, text: '1 hora' },
        { value: 90, text: '1h 30min' },
        { value: 120, text: '2 horas' },
      ],
      cidadesOptions: [],
      selectedCidade: null,
      estadosLoading: false,
      cidadesLoading: false,
      loadingInitialState: false,
    };
  },
  created() {
    this.certificados = this.array_certificados

    if (this.array_certificados.length > 0) {
      this.diretorio = this.array_certificados[0].nome
    }
    
    this.empresa = this.buildEmpresaSnapshot();
    this.$emit("newTitle", this.titleBody);
    this.loadEstados();
  },
  mounted() {
  },
  methods: {
    applyEmpresaFormDefaults(data) {
      applyEmpresaEvolutionPolicyDefaults(data);
    },
    buildEmpresaSnapshot() {
      let data = null;

      if (this.oldEmpresa) {
        data = { ...this.oldEmpresa };
      } else if (this.currentEmpresa) {
        data = { ...this.currentEmpresa };
      }

      this.applyEmpresaFormDefaults(data);

      return data;
    },
    seleciona_tp_ambiente(event){
       this.certificado.uhomprod = event?.id || null;
       if (this.empresa) {
        this.empresa.uhomprod = event?.id || null;
       }
    },
    seleciona_regime_trib(event) {
      if (this.empresa) {
        this.empresa.crt = event?.id || null;
      }
    },
    syncEmpresaSelects() {
      if (!this.empresa) return;

      const ambienteId = Number(this.empresa.uhomprod);
      this.select_ambiente = this.tipos.find((tipo) => Number(tipo.id) === ambienteId) || null;

      const regimeId = Number(this.empresa.crt);
      this.select_regime_trib = this.regimes.find((regime) => Number(regime.id) === regimeId) || null;
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    async uploadFile() {
      if(this.certificados.length == 1){
        this.makeToast('danger', 'certificado Já existe')
      }else {
        const formData = new FormData();
        formData.append("file", this.file);
        formData.append("password", this.password);
        this.certificado.razao_social = this.currentEmpresa.razao
        this.certificado.uf = this.currentEmpresa.uf
        this.certificado.cnpj = this.currentEmpresa.cnpj
        formData.append("razao", this.certificado.razao_social);
        formData.append("uf", this.certificado.uf);
        formData.append("cnpj", this.certificado.cnpj);
        formData.append("uhomprod", this.certificado.uhomprod);
        formData.append("empresa_id", this.currentEmpresa.id);
        this.abr_certificado = false;

        try {
          const response = await http.post("/nfe/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          if (response.status == 200) {
            this.makeToast("success", "upload feito");
          }

          setTimeout(() => {
            this.abr_certificado = true;
          }, 1000);
        } catch (error) {
          console.error("Erro no upload:", error);
        }
      }// fim else
    },
    makeToast(variant = null, message = "Error generic") {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: "b-toaster-bottom-right",
        variant: variant,
        solid: true,
        appendToast: true,
      });
    },
    handleFileChange(event) {
      this.diretorio = event.target.files[0].name;
      this.empresa.nome_certificado = this.diretorio // não precisa desses dois é so fazer um relacionamento com a table uploadas
      this.empresa.password = this.password
      this.file = event.target.files[0];
    },
    async post_enviar(event) {
      event.preventDefault();
      let certificado = this.file;
      certificado.empresa_id = this.currentEmpresa.id;
      certificado.user_id = this.currentUser.id;
      this.onLoader();

      try {
        let response = await http.post(
          "/certificado?empresa_id=" + this.currentEmpresa.id,
          certificado
        );

        if (response) {
          this.offLoader();

          if (response.status === 200) {
            this.getData();
            this.inserindo = false;
            this.makeToast("success", "certificado incluído");
          }
        }
      } catch (error) {
        this.offLoader();
        if (error.response) {
          if (error.response.status === 404) {
            this.makeToast("danger", "Destino URL não encontrado!");
          } else {
            this.makeToast("danger", error);
          }
        }
      }
    },
    async loadEstados() {
      this.estadosLoading = true;

      try {
        const response = await fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome');
        const data = await response.json();
        this.estados = data || [];

        if (this.empresa && this.empresa.uf && this.estados.length) {
          const ufSigla = typeof this.empresa.uf === 'string' ? this.empresa.uf : (this.empresa.uf?.sigla || this.empresa.uf?.nome);
          this.loadingInitialState = true;
          this.select_emp_uf = this.estados.find((e) => e.sigla === ufSigla || e.nome === ufSigla) || null;

          if (this.select_emp_uf) {
            await this.loadCidadesByEstado(this.select_emp_uf.id, true);
          }

          this.loadingInitialState = false;
        }
      } catch (error) {
        console.error('Erro ao carregar estados IBGE:', error);
        this.makeToast('danger', 'Erro ao carregar estados.');
      } finally {
        this.estadosLoading = false;
      }
    },
    async loadCidadesByEstado(estadoId, keepEmpresaCidadeId = false) {
      if (!estadoId) {
        this.cidadesOptions = [];
        this.selectedCidade = null;
        if (this.empresa) this.empresa.cidade_id = null;
        return;
      }

      this.cidadesLoading = true;
      this.cidadesOptions = [];
      this.selectedCidade = null;
      if (this.empresa && !keepEmpresaCidadeId) this.empresa.cidade_id = null;

      try {
        const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estadoId}/municipios?orderBy=nome`);
        const data = await response.json();
        this.cidadesOptions = data || [];
        this.syncSelectedCidadeFromEmpresa();
      } catch (error) {
        console.error('Erro ao carregar cidades IBGE:', error);
        this.makeToast('danger', 'Erro ao carregar cidades.');
      } finally {
        this.cidadesLoading = false;
      }
    },
    syncSelectedCidadeFromEmpresa() {
      if (!this.empresa || !this.cidadesOptions.length) return;
      const cidadeId = this.empresa.cidade_id;
      if (cidadeId == null || cidadeId === '') return;
      const idNum = Number(cidadeId);
      const found = this.cidadesOptions.find((c) => Number(c.id) === idNum || String(c.id) === String(cidadeId));
      this.selectedCidade = found || null;
    },
    async pesquisarCep() {
      if (!this.empresa) return;
      const cep = String(this.empresa.cep || '').replace(/\D/g, '');
      if (cep.length !== 8) {
        this.makeToast('warning', 'Informe um CEP válido com 8 dígitos.');
        return;
      }
      this.cepLoading = true;
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        const dados = await response.json();
        if (dados.erro) {
          this.makeToast('warning', 'CEP não encontrado.');
          return;
        }
        const ibgeCidadeId = dados.ibge ? parseInt(dados.ibge, 10) : null;
        const ufSigla = (dados.uf || '').trim().toUpperCase();

        this.empresa.endereco = dados.logradouro || '';
        this.empresa.bairo = dados.bairro || '';
        this.empresa.uf = ufSigla || '';

        if (this.estados.length === 0) {
          await this.loadEstados();
        }
        const estado = this.estados.find((e) => (e.sigla || '').toString().trim().toUpperCase() === ufSigla);
        if (!estado) {
          this.makeToast('warning', `Estado "${ufSigla || dados.uf}" não encontrado na lista. Verifique se os estados foram carregados.`);
        } else {
          this.loadingInitialState = true;
          this.select_emp_uf = estado;
          await this.loadCidadesByEstado(estado.id, true);
          this.empresa.cidade_id = ibgeCidadeId;
          this.syncSelectedCidadeFromEmpresa();
          this.$nextTick(() => {
            this.loadingInitialState = false;
          });
          this.makeToast('success', 'Endereço preenchido com sucesso.');
        }
      } catch (error) {
        console.error('Erro ao consultar ViaCEP:', error);
        this.makeToast('danger', 'Erro ao buscar CEP. Tente novamente.');
      } finally {
        this.cepLoading = false;
      }
    },
    adicionarSemDuplicatas(novoObjeto) {
      if (!novoObjeto) return;
      if (!this.estados.some((objeto) => objeto.nome === novoObjeto.nome)) {
        this.estados.push(novoObjeto);
      }
    },
    setNewTitle() {
      this.$emit("newTitle", "Alterar Empresa " + this.empresa.id);
    },
    setPut() {
      if (this.empresa && this.select_emp_uf?.sigla) {
        this.empresa.uf = this.select_emp_uf.sigla;
      }
      this.$emit("doPut", this.empresa);
    },
    back() {
      this.$emit("back");
    },
    async loadWorkingHours(empresaId = null) {
      const targetEmpresaId = empresaId || this.currentEmpresa?.id || this.empresa?.id;

      if (!targetEmpresaId) {
        return;
      }

      this.workingHoursLoading = true;
      try {
        const response = await http.get(`/empresa/${targetEmpresaId}/working-hours`);
        this.workingHours = response.data?.data || [];
      } catch (error) {
        this.makeToast("danger", this.$t("mesages.company.working_hours.error"));
      } finally {
        this.workingHoursLoading = false;
      }
    },
    async saveWorkingHours(updatedHours) {
      const targetEmpresaId = this.currentEmpresa?.id || this.empresa?.id;

      if (!targetEmpresaId) {
        return;
      }

      this.workingHoursSaving = true;
      try {
        const response = await http.put(`/empresa/${targetEmpresaId}/working-hours`, {
          working_hours: updatedHours,
        });
        this.workingHours = response.data?.data || [];
        this.makeToast("success", this.$t("mesages.company.working_hours.success"));
      } catch (error) {
        this.makeToast("danger", this.$t("mesages.company.working_hours.update_error"));
        throw error;
      } finally {
        this.workingHoursSaving = false;
      }
    },
  },
  watch: {
    select_emp_uf(val) {
      if (this.loadingInitialState) return;
      if (!val) {
        this.cidadesOptions = [];
        this.selectedCidade = null;
        if (this.empresa) {
          this.empresa.uf = null;
          this.empresa.cidade_id = null;
        }
        return;
      }
      if (this.empresa) {
        this.empresa.uf = val.sigla || val.nome || null;
      }
      this.loadCidadesByEstado(val.id);
    },
    selectedCidade(val) {
      if (this.empresa) {
        this.empresa.cidade_id = val ? val.id : null;
      }
    },
    currentEmpresa: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.id) {
          this.empresa = { ...newValue };
          this.applyEmpresaFormDefaults(this.empresa);
          this.syncEmpresaSelects();
          this.loadWorkingHours(newValue.id);
          if (this.estados.length && this.empresa.uf) {
            const ufSigla = typeof this.empresa.uf === 'string' ? this.empresa.uf : (this.empresa.uf?.sigla || this.empresa.uf?.nome);
            this.loadingInitialState = true;
            this.select_emp_uf = this.estados.find((e) => e.sigla === ufSigla || e.nome === ufSigla) || null;
            if (this.select_emp_uf) this.loadCidadesByEstado(this.select_emp_uf.id, true);
            this.$nextTick(() => { this.loadingInitialState = false; });
          }
        }
      },
    },
    oldEmpresa: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.id) {
          this.empresa = { ...newValue };
          this.applyEmpresaFormDefaults(this.empresa);
          this.syncEmpresaSelects();
          this.loadWorkingHours(newValue.id);
          if (this.estados.length && this.empresa.uf) {
            const ufSigla = typeof this.empresa.uf === 'string' ? this.empresa.uf : (this.empresa.uf?.sigla || this.empresa.uf?.nome);
            this.loadingInitialState = true;
            this.select_emp_uf = this.estados.find((e) => e.sigla === ufSigla || e.nome === ufSigla) || null;
            if (this.select_emp_uf) this.loadCidadesByEstado(this.select_emp_uf.id, true);
            this.$nextTick(() => { this.loadingInitialState = false; });
          }
        }
      },
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="accordion" role="tablist">
      <form role="form" class="form-horizontal">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.pedido-dados-gerais variant="light"
              >Informações da Empresa</b-button
            >
          </b-card-header>
          <b-collapse
            id="pedido-dados-gerais"
            visible
            accordion="pedido-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-2" id="cod_prod">
                  <div class="form-group">
                    <label for="empresa_id" class="col-form-label"
                      >Código</label
                    >
                    <div class="col">
                      <input
                        disabled
                        class="form-control text-right"
                        type="text"
                        placeholder="Gerado pelo sistema"
                        id="empresa_id"
                        v-model="empresa.id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3">
                  <div class="form-group">
                    <label for="empresa_cnpj" class="col-form-label"
                      >CNPJ</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.cnpj"
                        type="text"
                        inputmode="numeric"
                        maxlength="18"
                        class="form-control text-right"
                        placeholder="CNPJ"
                        id="empresa_cnpj"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-4">
                  <div class="form-group">
                    <label for="empresa-apelido" class="col-form-label">Apelido (Aparece na lista das empresas no login)</label>
                    <div class="col">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Digite um Apelido para a Empresa"
                        id="empresa-apelido"
                        v-model="empresa.apelido"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4" id="col-empresa-nome-fantasia">
                  <div class="form-group">
                    <label for="empresa-nome-fantasia" class="col-form-label">Nome Fantasia</label>
                    <div class="col">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Digite o Nome Fantasia da Empresa"
                        id="empresa-nome-fantasia"
                        v-model="empresa.fantasia"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4">
                  <div class="form-group">
                    <label for="empresa-razao-social" class="col-form-label">Razão Social</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.razao"
                        class="form-control"
                        type="text"
                        placeholder="Digite a Razão Social da Empresa"
                        id="empresa-razao-social"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group" id="espaco">
                <div class="col-sm-6 col-md-2">
                  <div class="form-group">
                    <label for="empresa_cep" class="col-form-label">CEP</label>
                    <div class="col d-flex">
                      <input
                        v-model="empresa.cep"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite o CEP"
                        id="empresa_cep"
                        @keyup.enter="pesquisarCep"
                      />
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        class="ml-1"
                        title="Buscar endereço pelo CEP (ViaCEP)"
                        @click="pesquisarCep"
                        :disabled="cepLoading"
                      >
                        <b-spinner v-if="cepLoading" small></b-spinner>
                        <span v-else>Buscar</span>
                      </b-button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-9">
                  <div class="form-group">
                    <label for="empresa_endereco" class="col-form-label"
                      >Endereço
                    </label>
                    <div class="col">
                      <input
                        v-model="empresa.endereco"
                        class="form-control"
                        placeholder="Digite o Endereço"
                        id="empresa_endereco"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-1">
                  <div class="form-group">
                    <label for="numero" class="col-form-label">Número</label>
                    <div class="col">
                      <input
                        v-model="empresa.numero"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite o Número"
                        id="empresa_numero"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group" id="espaco">
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="empresa_bairro" class="col-form-label">Bairro</label>
                    <div class="col">
                      <input
                        v-model="empresa.bairo"
                        type="text"
                        class="form-control"
                        placeholder="Digite o Bairro da Empresa"
                        id="empresa_bairro"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="empresa_complemento" class="col-form-label"
                      >Complemento</label
                    >
                    <div class="col">
                      <input 
                        v-model="empresa.complemento"
                        type="text"
                        class="form-control"
                        placeholder="Digite o Complemento da Empresa"
                        id="empresa_complemento"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <div class="form-group">
                    <label for="UF" class="col-form-label">UF</label>
                    <div class="col">
                      <Multiselect
                        v-model="select_emp_uf"
                        :options="estados"
                        :loading="estadosLoading"
                        label="nome"
                        track-by="id"
                        placeholder="Selecione o Estado"
                        selectLabel="Pressione ENTER para selecionar"
                        deselectLabel="Pressione ENTER para remover"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <div class="form-group">
                    <label for="empresa_cidade" class="col-form-label">Cidade</label>
                    <div class="col">
                      <Multiselect
                        v-model="selectedCidade"
                        :options="cidadesOptions"
                        :loading="cidadesLoading"
                        label="nome"
                        track-by="id"
                        placeholder="Selecione a Cidade"
                        selectLabel="Pressione ENTER para selecionar"
                        deselectLabel="Pressione ENTER para remover"
                        id="empresa_cidade"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group" id="espaco">
                <div class="col-sm-6 col-md-2">
                  <div class="form-group">
                    <label for="empresa_ie" class="col-form-label"
                      >Inscrição Estadual</label
                    >
                    <div class="col">
                      <input
                        v-model="empresa.ie"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite a Inscrição Estadual"
                        id="empresa_ie"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <div class="form-group">
                    <label for="empresa_im" class="col-form-label"
                      >Inscrição Municipal
                    </label>
                    <div class="col">
                      <input
                        v-model="empresa.im"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite a Inscrição Municipal"
                        id="empresa_im"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-2">
                  <div class="form-group">
                    <label for="empresa_telefone" class="col-form-label"
                      >Telefone</label
                    >
                    <div class="col">
                      <input
                       v-model="empresa.fone"
                        type="text"
                        class="form-control text-right"
                        placeholder="Digite o Telefone"
                        id="empresa_telefone"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3">
                  <div class="form-group">
                    <label for="empresa_agenda_slot_duration" class="col-form-label"
                      >Intervalo da Agenda (minutos)</label
                    >
                    <div class="col">
                      <b-form-select
                        id="empresa_agenda_slot_duration"
                        v-model="empresa.agenda_slot_duration_minutes"
                        :options="agendaSlotDurationOptions"
                        class="form-control"
                        placeholder="Selecione o Intervalo da Agenda"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 mt-2">
                  <div class="form-group">
                    <b-form-checkbox
                      id="empresa_bloquear_evolucao_meses_retroativos"
                      v-model="empresa.bloquear_evolucao_meses_retroativos"
                      name="bloquear_evolucao_meses_retroativos"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Bloquear parecer e evolução em meses retroativos
                    </b-form-checkbox>
                    <small class="form-text text-muted">
                      Com a opção desligada, o profissional pode registrar parecer em atendimentos de meses anteriores até o fim do mês atual. Meses futuros continuam bloqueados.
                    </small>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
          <!-- Menus de Impostos-->
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.pedido-complementares variant="light"
              >Dados NFE</b-button
            >
          </b-card-header>
          <b-collapse id="pedido-complementares">
            <b-card-body>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="empresa_CSOSN" class="col-form-label"
                      >chave de acesso</label
                    >
                    <div class="col">
                      <input
                        type="text"
                        class="form-control text-left"
                        id="empresa_CSOSN"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="empresa_tokensefaz" class="col-form-label"
                      >Token Sefaz</label
                    >
                    <div class="col">
                      <input
                        type="text"
                        class="form-control text-left"
                        id="empresa_tokensefaz"
                        v-model="empresa.tokensefaz"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="empresa_idtokensefaz" class="col-form-label"
                      >ID Token Sefaz</label
                    >
                    <div class="col">
                      <input
                        type="text"
                        class="form-control text-left"
                        id="empresa_idtokensefaz"
                        v-model="empresa.idtokensefaz"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="empresa_tpAmbiente" class="col-form-label"
                      >Tipo de Ambiente</label
                    >
                    <div class="col">
                      <Multiselect
                        label="nome"
                        @select="seleciona_tp_ambiente($event)"
                        @remove="seleciona_tp_ambiente(null)"
                        v-model="select_ambiente"
                        :options="tipos"
                        track-by="id"
                        placeholder="Selecione o ambiente"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label for="empresa_regimeTributario" class="col-form-label"
                      >Regime tributario</label
                    >
                    <div class="col">
                      <Multiselect
                        :options="regimes"
                        id="empresa_regimeTributario"
                        label="nome"
                        track-by="id"
                        v-model="select_regime_trib"
                        @select="seleciona_regime_trib($event)"
                        @remove="seleciona_regime_trib(null)"
                        placeholder="Selecione o regime tributário"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>

          <!--- ------------ -->

          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.pdv-ipi variant="light2"
              >Certficado</b-button
            >
          </b-card-header>
          <b-collapse id="pdv-ipi">
            <b-card-body>
              <div class="form-row form-group" role="group">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="s_tributaria" class="col-form-label"
                      >Carregar Certificado no Computador</label
                    >
                    <div class="col">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="customFile"
                          @change="handleFileChange($event)"
                        />

                        <label class="custom-file-label" for="customFile">{{
                          diretorio || "Selecionar o Certificado"
                        }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="cod_enq" class="col-form-label"
                      >Carregar Certificado No Banco</label
                    >
                    <div class="col">
                      <button
                        class="btn btn-light"
                        @click.prevent="uploadFile()"
                      >
                        Carregar
                      </button>
                      <button class="btn btn-light ml-2 mr-2">
                        Ler configurações
                      </button>
                      <button class="btn btn-light">Status</button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label for="certificado" class="col-form-label"
                      >Senha</label
                    >
                    {{password}}
                    <div class="col">
                      <input
                        type="text"
                        class="form-control text-left"
                        id="certificado_id"
                        v-model="password"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row form-group" role="group"></div>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- engloba  todos-->
      </form>
      <!-- form engloba todos-->
      <b-card class="mb-3">
        <template #header>
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{ $t("mesages.company.working_hours.title") }}</h5>
            <small class="text-muted">{{ $t("mesages.company.working_hours.subtitle") }}</small>
          </div>
        </template>
        <WorkingHoursForm
          :working-hours="workingHours"
          :loading="workingHoursLoading"
          :saving="workingHoursSaving"
          @save="saveWorkingHours"
        />
      </b-card>
    </div>
    <!--Engloba todos -->
    <div class="card-body">
      <div class="col-md-12 mt-10">
        <button class="btn btn-warning mr-3" @click="back()">Cancelar</button>
        <button type="button" class="btn btn-success mr-3" @click="setPut()">Gravar</button>
      </div>
    </div>
  </div>
</template>
